///<reference path="../common/smart-mover.models.ts"/>
///<reference path="../common/data-template-base.ts"/>
///<reference path="../filter-templates/point-promotions.filter.ts"/>
///<reference path="../collections/report-payment-types.collection.ts"/>

module Meevo.Components.Controls.SmartMover {

    import Dictionary = _.Dictionary;

    export class PaymentTypesDataTemplate extends DataTemplateBase implements IDataTemplate {

        protected paymentTypes: ReportPaymentTypesCollection;

        public title: string;
        public allSelectedLabel: string;
        public totalSelectedMessage: string;

        get collection() {
            return this.paymentTypes;
        }

        constructor(model: Dictionary<any>, properties: string[], {criteria}) {
            super(model, properties, criteria);

            this.paymentTypes = new ReportPaymentTypesCollection(this.model[properties[0]], [], {criteria});

            this.tips = [
                'TIP_NOT_SELECTING_PAYMENT_TYPE',
                'NOTE_PAYMENT_TYPES'
            ];
            this.title = 'LABEL_PAYMENT_TYPE';
            this.allSelectedLabel = 'LABEL_ALL_PAYMENT_TYPES';
            this.totalSelectedMessage = 'LABEL_TOTAL_PAYMENT_TYPES_SELECTED';
        }
    }
}